const isNotNullOrUndefined = (value: any) =>
  value !== null && value !== undefined;

const getValueGeneric = <TResult>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  input: any,
  path: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getResult: (input: any, path: string) => TResult
): TResult | null => {
  const indexOfDot = path.indexOf(".");
  const indexOfArray = path.indexOf("[");

  if (indexOfDot !== -1 && (indexOfDot < indexOfArray || indexOfArray === -1)) {
    const valueName = path.substring(0, indexOfDot);

    if (isNotNullOrUndefined(input) && valueName in input) {
      return getValueGeneric(
        input[valueName],
        path.substring(indexOfDot + 1),
        getResult
      );
    }
  }

  if (indexOfArray > 0 && (indexOfArray < indexOfDot || indexOfDot === -1)) {
    const valueName = path.substring(0, indexOfArray);

    if (isNotNullOrUndefined(input) && valueName in input) {
      return getValueGeneric(
        input[valueName],
        path.substring(indexOfArray),
        getResult
      );
    }
  }

  if (indexOfArray === 0) {
    const matchArray = path.match(/\[(.*?)\]/);

    if (matchArray && isNotNullOrUndefined(input) && Array.isArray(input)) {
      return getValueGeneric(
        input[Number(matchArray[1])],
        path.substring(path.indexOf("]") + 2),
        getResult
      );
    }

    return null;
  }

  return getResult(input, path);
};

export const getNumberOfItemsInArray = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  paramInput: any,
  paramPath: string
): number =>
  getValueGeneric(paramInput, paramPath, (input, path) => {
    if (
      isNotNullOrUndefined(input) &&
      path in input &&
      Array.isArray(input[path])
    ) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (input[path] as any[]).length;
    }

    return 0;
  }) ?? 0;

export const getValueFromObject = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  paramInput: any,
  paramPath: string
): string | null =>
  getValueGeneric(paramInput, paramPath, (input, path) => {
    if (isNotNullOrUndefined(input) && path in input) {
      return input[path];
    }
    return null;
  });

export const getArrayValueFromObject = (
  paramInput: any,
  paramPath: string
): any[] | null =>
  getValueGeneric(paramInput, paramPath, (input, path) => {
    if (
      isNotNullOrUndefined(input) &&
      path in input &&
      Array.isArray(input[path])
    ) {
      return input[path];
    }

    return null;
  });

export const getObjectValueFromObject = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  paramInput: any,
  paramPath: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any | null =>
  getValueGeneric(paramInput, paramPath, (input, path) => {
    if (paramPath.endsWith("]")) {
      return input;
    }
    if (isNotNullOrUndefined(input) && path in input) {
      return input[path];
    }
    return null;
  });

export const isValueNotGiven = (value: any) => {
  return (
    value === null ||
    value === undefined ||
    Object.keys(value)
      .map((key) => value[key])
      .every(
        (item) =>
          item === undefined || (Array.isArray(item) && item.length === 0)
      )
  );
};
